const heightMobile = "368px";
const heightTablet = "440px";
const heightDesktop = "598px";

module.exports = (theme) => ({
  ".direct-search-container": {
    position: "relative",
    width: "100%",
    maxWidth: "1920px",
    marginRight: "auto",
    marginLeft: "auto",
  },
  ".direct-search-content-container": {
    position: "relative",
    height: "100%",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  ".direct-search-bg-image": {
    backgroundColor: theme("colors.primary.gray.DEFAULT"),
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    display: "none",
    inset: "0",
    position: "absolute",
  },
  ".direct-search-bg-video": {
    height: "100%",
    inset: "0",
    objectFit: "cover",
    overflow: "hidden",
    position: "absolute",
    width: "100%",
  },
  ".direct-search-fade-in": {
    animationName: "fade-in-opacity",
    animationDuration: "2s",
    animationIterationCount: "1",
    animationTimingFunction: "ease-in",
    transition: "opacity",
    opacity: 1,
  },
  "@keyframes fade-in-opacity": { "0%": { opacity: 0 }, "100%": { opacity: 1 } },
  [`@media screen and (max-width: ${theme("screens.sm")})`]: {
    ".direct-search-container": { height: `${heightMobile}` },
    ".direct-search-bg-image-mobile": { display: "block" },
  },
  [`@media screen and (min-width: ${theme("screens.sm")})`]: {
    ".direct-search-container": { height: `${heightTablet}` },
    ".direct-search-bg-image-tablet": { display: "block" },
  },
  [`@media screen and (min-width: ${theme("screens.lg")})`]: {
    ".direct-search-container": { height: `${heightDesktop}` },
    ".direct-search-bg-image-desktop": { display: "block" },
  },
});
